// extracted by mini-css-extract-plugin
module.exports = {"container":"JournalCategory_container__td_a1"};